import { LogEntityComponent } from '@/ui/components/activityLogs/factory/LogEntityComponent';
import { IssueActivities } from '@/entities/activity/constants';
import { Comment, Created, FieldRemoved, FieldUpdated } from '@/ui/components/activityLogs/types/issue';
import ApprovalApproved from '@/ui/components/activityLogs/types/inspection/ApprovalApproved.vue';
import ApprovalRejected from '@/ui/components/activityLogs/types/inspection/ApprovalRejected.vue';
import ApprovalDeleted from '@/ui/components/activityLogs/types/inspection/ApprovalDeleted.vue';
import ApprovalChangesRequested from '@/ui/components/activityLogs/types/inspection/ApprovalChangesRequested.vue';
import ApprovalReset from '@/ui/components/activityLogs/types/inspection/ApprovalReset.vue';

export class LogIssueComponent implements LogEntityComponent {
  // eslint-disable-next-line class-methods-use-this
  getComponent(activity: IssueActivities) {
    switch (activity) {
      case IssueActivities.Created:
        return Created;
      case IssueActivities.FieldUpdated:
        return FieldUpdated;
      case IssueActivities.CommentAdded:
        return Comment;
      case IssueActivities.FieldRemoved:
        return FieldRemoved;
      case IssueActivities.ApprovalApproved:
        return ApprovalApproved;
      case IssueActivities.ApprovalRejected:
        return ApprovalRejected;
      case IssueActivities.ApprovalDeleted:
        return ApprovalDeleted;
      case IssueActivities.ApprovalChangesRequested:
        return ApprovalChangesRequested;
      case IssueActivities.ApprovalReset:
        return ApprovalReset;
      default:
        throw new Error(`Log Issue factory for activity '${activity}' not implemented`);
    }
  }
}
